var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop_table",class:{ shop_table_limit_2: _vm.product_count <= 2 }},[_c('pre',[_vm._v("activeProductIds: "+_vm._s(_vm.activeProductIds))]),_vm._l((_vm.products),function(p,i){return _c('shop-row',{key:'shop-table-products-' + _vm.isPackage
          ? p.PackageKey
          : p.EntityHierarchyKey + '-' + i,attrs:{"row":p,"isPackage":_vm.isPackage}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }